export default __webpack_public_path__ + "static/media/convertise.0665409d.svg";